import store from 'root/store.js'

export function authCheck (aRoute) {
	const token = localStorage.getItem('token')
	const routes = getRoutes()
	const validPath = routes.find(route => route.path === aRoute)

	if (token === null || token === '') {
		return '/'
	}

	if (validPath === undefined || validPath.level < 2) {
		return '/' + routes[0].path + '/'
	}

	return null
}

export function getToken () {
  'use strict'
  const token = localStorage.getItem('token')
  if (token === null || token === '') {
    return ''
  } else {
    return token
  }
}

export function getSuperiorID () {
  'use strict'
  const ID = parseInt(localStorage.getItem('superior_id'))
  if (isNaN(ID)) {
    return -1
  } else {
    return ID
  }
}

export function getRoutes () {
  'use strict'
  const routes = JSON.parse(localStorage.getItem('routes'))
  if (routes === null || !Array.isArray(routes)) {
    return []
  } else {
    return routes
  }
}

export function getUserID () {
  'use strict'
  const ID = parseInt(localStorage.getItem('user_id'))
  if (isNaN(ID)) {
    return -1
  } else {
    return ID
  }
}

export function setToken (token) {
  localStorage.setItem('token', token.token)
  localStorage.setItem('routes', JSON.stringify(token.routes))
  localStorage.setItem('superior_id', token.superior_id)
  localStorage.setItem('user_id', token.user_id)
}

export function clearToken () {
  localStorage.removeItem('token')
  localStorage.removeItem('routes')
  localStorage.removeItem('superior_id')
  localStorage.removeItem('user_id')

  store.commit('clear')
}



// WEBPACK FOOTER //
// ./src/functions/auth_check.js